import React from "react";
import { TrialActivatedModalTemplate } from "themes/application/payment/components";

function TrialActivatedModal(props) {
    return <TrialActivatedModalTemplate {...props} />;
}

export default TrialActivatedModal;
